import React, { useState, useEffect } from 'react';
import { Save, RefreshCw, Plus } from 'lucide-react';
import { adminAPI } from '../lib/api';

const AdminBaremesTICFE = () => {
  const [activeTab, setActiveTab] = useState('bt_inf');
  const [baremes, setBaremes] = useState({
    bt_inf: {},
    bt_sup: {},
    ht: {}
  });
  const [annees, setAnnees] = useState(['2023', '2024', '2025', '2026', '2027']);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showAddYear, setShowAddYear] = useState(false);
  const [newYear, setNewYear] = useState('');
  const [dataSource, setDataSource] = useState('default');

  const CATEGORIES = [
    { id: 'bt_inf', label: 'BT Inférieur (< 36 kVA)', color: 'bg-[#10D183]' },
    { id: 'bt_sup', label: 'BT Supérieur (36-250 kVA)', color: 'bg-[#397DFF]' },
    { id: 'ht', label: 'HT (> 250 kVA)', color: 'bg-[#F9C80E]' }
  ];

  const ANNEES = annees; // Utiliser annees dynamique au lieu de hardcodé
  const MOIS = [
    { num: 1, label: 'Janvier' },
    { num: 2, label: 'Février' },
    { num: 3, label: 'Mars' },
    { num: 4, label: 'Avril' },
    { num: 5, label: 'Mai' },
    { num: 6, label: 'Juin' },
    { num: 7, label: 'Juillet' },
    { num: 8, label: 'Août' },
    { num: 9, label: 'Septembre' },
    { num: 10, label: 'Octobre' },
    { num: 11, label: 'Novembre' },
    { num: 12, label: 'Décembre' }
  ];

  useEffect(() => {
    loadBaremes();
  }, []);

  const loadBaremes = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getBaremesTICFE();
      const { data, source } = response.data;
      setBaremes(data);
      setDataSource(source);
      
      // Extraire les années disponibles
      const yearsSet = new Set();
      Object.values(data).forEach(cat => {
        Object.values(cat).forEach(moisData => {
          Object.keys(moisData).forEach(year => yearsSet.add(year));
        });
      });
      if (yearsSet.size > 0) {
        setAnnees(Array.from(yearsSet).sort());
      }
    } catch (error) {
      console.error('Erreur chargement barèmes:', error);
      // Charger les valeurs par défaut en cas d'erreur
      setBaremes(initializeBareme());
    } finally {
      setLoading(false);
    }
  };

  const initializeBareme = () => {
    // Charger depuis fichier Excel Ref
    const baremesExcel = {
      "bt_inf": {
        "1": {"2023": 1, "2024": 1, "2025": 21, "2026": 29.98, "2027": 30.85},
        "2": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "3": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "4": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "5": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "6": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "7": {"2023": 1, "2024": 21, "2025": 33.7, "2026": 30.85, "2027": 30.85},
        "8": {"2023": 1, "2024": 21, "2025": 29.98, "2026": 30.85, "2027": 30.85},
        "9": {"2023": 1, "2024": 21, "2025": 29.98, "2026": 30.85, "2027": 30.85},
        "10": {"2023": 1, "2024": 21, "2025": 29.98, "2026": 30.85, "2027": 30.85},
        "11": {"2023": 1, "2024": 21, "2025": 29.98, "2026": 30.85, "2027": 30.85},
        "12": {"2023": 1, "2024": 21, "2025": 29.98, "2026": 30.85, "2027": 30.85}
      },
      "bt_sup": {
        "1": {"2023": 0.5, "2024": 0.5, "2025": 20.5, "2026": 25.79, "2027": 26.58},
        "2": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "3": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "4": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "5": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "6": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "7": {"2023": 0.5, "2024": 20.5, "2025": 26.23, "2026": 25.79, "2027": 26.58},
        "8": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "9": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "10": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "11": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "12": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58}
      },
      "ht": {
        "1": {"2023": 0.5, "2024": 0.5, "2025": 20.5, "2026": 25.79, "2027": 26.58},
        "2": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "3": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "4": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "5": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "6": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "7": {"2023": 0.5, "2024": 20.5, "2025": 22.5, "2026": 25.79, "2027": 26.58},
        "8": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "9": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "10": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "11": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58},
        "12": {"2023": 0.5, "2024": 20.5, "2025": 25.79, "2026": 25.79, "2027": 26.58}
      }
    };
    
    return baremesExcel;
  };

  const updateTarif = (categorie, mois, annee, valeur) => {
    const newBaremes = { ...baremes };
    if (!newBaremes[categorie][mois]) newBaremes[categorie][mois] = {};
    newBaremes[categorie][mois][annee] = parseFloat(valeur) || 0;
    setBaremes(newBaremes);
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!window.confirm('Enregistrer les modifications des barèmes TICFE ?')) return;
    
    setSaving(true);
    try {
      await adminAPI.updateAllBaremesTICFE(baremes);
      alert('Barèmes sauvegardés avec succès !');
      setHasChanges(false);
      setDataSource('database');
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert(error.response?.data?.detail || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const handleReset = () => {
    if (!window.confirm('Annuler toutes les modifications ?')) return;
    loadBaremes();
    setHasChanges(false);
  };

  const handleAddYear = () => {
    const year = parseInt(newYear);
    if (!year || year < 2020 || year > 2040) {
      alert('Année invalide (2020-2040)');
      return;
    }
    if (annees.includes(newYear)) {
      alert('Cette année existe déjà');
      return;
    }

    // Ajouter année
    const newAnnees = [...annees, newYear].sort();
    setAnnees(newAnnees);
    
    // Initialiser barèmes pour cette année (copier dernière année)
    const lastYear = annees[annees.length - 1];
    const newBaremes = { ...baremes };
    
    ['bt_inf', 'bt_sup', 'ht'].forEach(cat => {
      Object.keys(newBaremes[cat]).forEach(mois => {
        newBaremes[cat][mois][newYear] = newBaremes[cat][mois][lastYear] || 25.79;
      });
    });
    
    setBaremes(newBaremes);
    setHasChanges(true);
    setShowAddYear(false);
    setNewYear('');
    alert(`Année ${year} ajoutée avec valeurs copiées de ${lastYear}`);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#397DFF]"></div></div>;
  }

  const currentBareme = baremes[activeTab] || {};

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-heading font-semibold text-[#191D1E] tracking-tight">Administration Barèmes TICFE</h1>
          <p className="text-[#687175] mt-2">
            Gestion des tarifs TICFE par catégorie de tension et période
            {dataSource === 'database' && <span className="ml-2 text-xs bg-[#10D183]/10 text-[#10D183] px-2 py-1 rounded">Depuis BDD</span>}
            {dataSource === 'default' && <span className="ml-2 text-xs bg-[#F9C80E]/10 text-[#F9C80E] px-2 py-1 rounded">Valeurs par défaut</span>}
          </p>
        </div>
        <div className="flex gap-3">
          <button onClick={() => setShowAddYear(true)} className="flex items-center gap-2 border border-[#397DFF] text-[#397DFF] hover:bg-[#397DFF] hover:text-white font-medium py-3 px-6 rounded-lg transition-colors">
            <Plus className="w-5 h-5" /> Ajouter Année
          </button>
          {hasChanges && (
            <button onClick={handleReset} className="flex items-center gap-2 border border-[#BFC6CC] text-[#687175] hover:bg-[#F5F6F9] font-medium py-3 px-6 rounded-lg transition-colors">
              <RefreshCw className="w-5 h-5" /> Annuler
            </button>
          )}
          <button onClick={handleSave} disabled={!hasChanges || saving} className="flex items-center gap-2 bg-[#397DFF] hover:bg-[#4672B6] text-white font-medium py-3 px-6 rounded-lg transition-colors disabled:opacity-50">
            <Save className="w-5 h-5" /> {saving ? 'Sauvegarde...' : 'Enregistrer'}
          </button>
        </div>
      </div>

      {/* Onglets */}
      <div className="flex gap-2 mb-6">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setActiveTab(cat.id)}
            className={`flex-1 py-3 px-6 font-medium rounded-lg transition-all ${
              activeTab === cat.id
                ? 'bg-[#397DFF] text-white shadow-md'
                : 'bg-white border border-[#BFC6CC] text-[#687175] hover:border-[#397DFF]'
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Message modifications */}
      {hasChanges && (
        <div className="mb-6 p-4 bg-[#F9C80E]/10 border border-[#F9C80E] rounded-lg">
          <p className="text-sm text-[#191D1E]">⚠️ Vous avez des modifications non enregistrées</p>
        </div>
      )}

      {/* Tableau éditable */}
      <div className="bg-white border border-[#BFC6CC] rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#F5F6F9]">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-[#191D1E] sticky left-0 bg-[#F5F6F9] border-r border-[#BFC6CC]">
                  Mois
                </th>
                {ANNEES.map((annee) => (
                  <th key={annee} className="px-4 py-3 text-center text-sm font-semibold text-[#191D1E] border-l border-[#BFC6CC]">
                    {annee}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#BFC6CC]">
              {MOIS.map((mois) => (
                <tr key={mois.num} className="hover:bg-[#F5F6F9]/50">
                  <td className="px-4 py-3 font-medium text-[#191D1E] sticky left-0 bg-white border-r border-[#BFC6CC]">
                    {mois.label}
                  </td>
                  {ANNEES.map((annee) => (
                    <td key={`${mois.num}-${annee}`} className="px-2 py-2 border-l border-[#BFC6CC]">
                      <input
                        type="number"
                        step="0.01"
                        value={currentBareme[mois.num]?.[annee] || ''}
                        onChange={(e) => updateTarif(activeTab, mois.num, annee, e.target.value)}
                        className="w-full px-3 py-2 text-center border border-[#BFC6CC] rounded focus:ring-2 focus:ring-[#397DFF] focus:border-[#397DFF] font-mono text-sm"
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-4 bg-[#F5F6F9] border-t border-[#BFC6CC]">
          <div className="flex items-center gap-4 text-sm text-[#687175]">
            <span>💡 Saisissez les tarifs en €/MWh</span>
            <span className="px-3 py-1 bg-[#F9C80E]/10 border border-[#F9C80E] rounded text-[#F9C80E] text-xs">
              ⚠️ Tarifs août-déc 2026 temporaires (décret à venir)
            </span>
          </div>
        </div>
      </div>
      {/* Modal Ajouter Année */}
      {showAddYear && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-8">
            <h2 className="text-2xl font-heading font-semibold text-[#191D1E] mb-6">Ajouter une Année</h2>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-[#191D1E] mb-2">Année</label>
              <input
                type="number"
                min="2020"
                max="2040"
                value={newYear}
                onChange={(e) => setNewYear(e.target.value)}
                placeholder="Ex: 2028"
                className="w-full px-4 py-3 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] font-mono text-lg"
                autoFocus
              />
              <p className="text-xs text-[#687175] mt-2">
                Les barèmes de l'année précédente seront copiés comme valeurs initiales
              </p>
            </div>

            <div className="flex gap-3">
              <button onClick={() => { setShowAddYear(false); setNewYear(''); }} className="flex-1 px-6 py-3 border border-[#BFC6CC] text-[#687175] font-medium rounded-lg hover:bg-[#F5F6F9]">
                Annuler
              </button>
              <button onClick={handleAddYear} className="flex-1 bg-[#397DFF] hover:bg-[#4672B6] text-white font-medium py-3 px-6 rounded-lg">
                Ajouter
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminBaremesTICFE;
